export default __webpack_public_path__ + "static/style4.5_Andrey-085098b1f9ddd7406ddc0dd3342af616.wav";